import React from 'react'
import './DescriptionBox.css'


const DescriptionBox = () => {
    return (
        <div className='descriptionbox'>
            <div className="descriptionbox-navigator">
                <div className="descriptionbox-nav-box">Mô tả</div>
                <div className="descriptionbox-nav-box fade">Đánh giá (5.7k)</div>
            </div>
            <div className="descriptionbox-description">
                <p>Căn hộ dịch vụ này là một điểm đến lý tưởng cho những ai đang tìm kiếm sự thoải mái 
                    và tiện nghi. Với không gian rộng rãi và thiết kế hiện
                    đại, căn hộ tạo cảm giác ấm cúng nhưng vẫn sang trọng.
                    Nội thất được trang bị đầy đủ và chất lượng, từ phòng
                    ngủ đến phòng khách và nhà bếp. Khách hàng cũng được phục vụ bởi dịch vụ chăm sóc khách hàng tận tình, 
                    giúp họ cảm thấy như ở nhà mỗi khi đặt chân vào căn hộ.
                    Với tiện ích như phòng tập gym, hồ bơi, và khu vực giải trí, đây là nơi lý tưởng để thư giãn và tận hưởng cuộc sống đẳng cấp.</p>

            </div>
        </div>
    )  
}

export default DescriptionBox
